import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useState } from 'react';

const UTM_PARAMS_TO_BE_SAVED_IN_SESSION_STORAGE = [
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
];

const UtmContext = createContext({ isUtmLoaded: false });

UtmContext.displayName = 'UtmContext';

const UtmProvider = ({ children }) => {
  const [isUtmLoaded, setIsUtmLoaded] = useState(false);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    urlSearchParams.forEach(async (value, key) => {
      if (UTM_PARAMS_TO_BE_SAVED_IN_SESSION_STORAGE.includes(key)) {
        const { setSessionStorage } = await import('lib/sessionStorage');
        setSessionStorage(key, value);
      }
    });

    setIsUtmLoaded(true);
  }, []);

  return (
    <UtmContext.Provider value={{ isUtmLoaded }}>
      {children}
    </UtmContext.Provider>
  );
};

UtmProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useUtm = () => useContext(UtmContext);

export default UtmProvider;

export { useUtm };
